import React, { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface BulletedListProps {
  children: ReactNode;
  className?: string;
}

export default function BulletedList({
  children,
  className,
}: BulletedListProps) {
  const hasValidChildren = React.Children.toArray(children).some((child) => {
    if (!child) return false;
    if (typeof child === "string" && !child.trim()) return false;
    return true;
  });

  if (!hasValidChildren) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex flex-wrap items-center text-xs text-ink-subtle",
        // Note: using CSS to handle bullets ensures they only appear for children that actually render to the DOM
        "gap-x-1.5 [&>*:not(:first-child)]:before:content-['•'] [&>*:not(:first-child)]:before:text-ink-faint [&>*:not(:first-child)]:before:mr-1.5",
        className,
      )}
    >
      {children}
    </div>
  );
}
